interface Banner {
  showInHome: boolean;
  showInMovements: boolean;
  metadata: any;
}

export interface BannersMap {
  [key: string]: Banner;
}

export enum BannerOrigin {
  home = 'home',
  movements = 'movements',
}

export enum BannerNames {
  withdrawalError = 'withdrawalError',
}

export enum BannerDocs {
  withdrawalErrorBanner = 'withdrawalErrorBanner',
}
